/**
 * ENGAPE POST — Cloudinary asset manifest.
 *
 * ⚠ GENERATED FILE. Do not edit by hand.
 *   Regenerate with `npm run images:upload` (scripts/cloudinary-upload.mjs).
 *
 * This file is committed deliberately. It is the reason the build no longer
 * needs the photographs on disk: every image the site renders is resolved from
 * the public IDs below, so `src/Images/*.jpg` and `public/gallery/` can stay
 * gitignored while Netlify still builds a complete site.
 *
 * Nothing secret lives here. A cloud name and a public ID are both visible in
 * any image URL the browser requests; the API secret stays in .env.local.
 */

export const CLOUD_NAME = "dhew50ten";

/** Uploaded 93 assets — 2026-10-19. */
export const assets = {
  aboutApproach: { id: "engape/site/about-approach", v: 1784645805, w: 1200, h: 800, f: "jpg" },
  aboutStory: { id: "engape/site/about-story", v: 1784645805, w: 1200, h: 800, f: "jpg" },
  ctaBand: { id: "engape/site/cta-band", v: 1784645804, w: 1400, h: 600, f: "jpg" },
  hero: { id: "engape/site/hero", v: 1784645805, w: 1200, h: 1200, f: "jpg" },
  progEducation: { id: "engape/site/prog-education", v: 1784645804, w: 900, h: 680, f: "jpg" },
  progEnvironment: { id: "engape/site/prog-environment", v: 1784645805, w: 900, h: 680, f: "jpg" },
  progFgm: { id: "engape/site/prog-fgm", v: 1784645805, w: 900, h: 680, f: "jpg" },
  progGbv: { id: "engape/site/prog-gbv", v: 1784645806, w: 900, h: 680, f: "jpg" },
  progLivelihoods: { id: "engape/site/prog-livelihoods", v: 1784645807, w: 900, h: 680, f: "jpg" },
  spotlightLibrary: { id: "engape/site/spotlight-library", v: 1784645806, w: 1200, h: 900, f: "jpg" },
  welcome: { id: "engape/site/welcome", v: 1784645807, w: 1100, h: 860, f: "jpg" },
  wideAbout: { id: "engape/site/wide-about", v: 1784645807, w: 1600, h: 620, f: "jpg" },
  wideContact: { id: "engape/site/wide-contact", v: 1784645807, w: 1600, h: 620, f: "jpg" },
  wideEducation: { id: "engape/site/wide-education", v: 1784645807, w: 1600, h: 620, f: "jpg" },
  wideEnvironment: { id: "engape/site/wide-environment", v: 1784645808, w: 1600, h: 620, f: "jpg" },
  wideEvents: { id: "engape/site/wide-events", v: 1784645808, w: 1600, h: 620, f: "jpg" },
  wideFgm: { id: "engape/site/wide-fgm", v: 1784645808, w: 1600, h: 620, f: "jpg" },
  wideGallery: { id: "engape/site/wide-gallery", v: 1784645808, w: 1600, h: 620, f: "jpg" },
  wideGbv: { id: "engape/site/wide-gbv", v: 1784645808, w: 1600, h: 620, f: "jpg" },
  wideInvolved: { id: "engape/site/wide-involved", v: 1784645809, w: 1600, h: 620, f: "jpg" },
  wideLivelihoods: { id: "engape/site/wide-livelihoods", v: 1784645809, w: 1600, h: 620, f: "jpg" },
  wideStories: { id: "engape/site/wide-stories", v: 1784645809, w: 1600, h: 620, f: "jpg" },
  logoRaster: { id: "engape/brand/logo", v: 1784645810, w: 438, h: 330, f: "png" },
  "community-01": { id: "engape/gallery/community-01", v: 1784645809, w: 1500, h: 1000, f: "jpg" },
  "community-02": { id: "engape/gallery/community-02", v: 1784645810, w: 1192, h: 802, f: "jpg" },
  "community-03": { id: "engape/gallery/community-03", v: 1784645810, w: 960, h: 1280, f: "jpg" },
  "community-04": { id: "engape/gallery/community-04", v: 1784645810, w: 1164, h: 760, f: "jpg" },
  "community-05": { id: "engape/gallery/community-05", v: 1784645810, w: 1169, h: 782, f: "jpg" },
  "community-06": { id: "engape/gallery/community-06", v: 1784645810, w: 1200, h: 813, f: "jpg" },
  "education-01": { id: "engape/gallery/education-01", v: 1784645811, w: 1500, h: 1000, f: "jpg" },
  "education-02": { id: "engape/gallery/education-02", v: 1784645811, w: 1500, h: 1000, f: "jpg" },
  "education-03": { id: "engape/gallery/education-03", v: 1784645811, w: 1500, h: 1000, f: "jpg" },
  "education-04": { id: "engape/gallery/education-04", v: 1784645811, w: 1500, h: 1000, f: "jpg" },
  "education-05": { id: "engape/gallery/education-05", v: 1784645811, w: 1500, h: 1000, f: "jpg" },
  "education-06": { id: "engape/gallery/education-06", v: 1784645811, w: 1500, h: 1000, f: "jpg" },
  "education-07": { id: "engape/gallery/education-07", v: 1784645812, w: 1500, h: 1000, f: "jpg" },
  "education-08": { id: "engape/gallery/education-08", v: 1784645812, w: 1500, h: 1000, f: "jpg" },
  "education-09": { id: "engape/gallery/education-09", v: 1784645812, w: 1500, h: 1000, f: "jpg" },
  "education-10": { id: "engape/gallery/education-10", v: 1784645812, w: 1500, h: 1000, f: "jpg" },
  "education-11": { id: "engape/gallery/education-11", v: 1784645812, w: 1500, h: 1000, f: "jpg" },
  "education-12": { id: "engape/gallery/education-12", v: 1784645812, w: 1500, h: 1000, f: "jpg" },
  "environment-01": { id: "engape/gallery/environment-01", v: 1784645813, w: 1472, h: 1104, f: "jpg" },
  "environment-02": { id: "engape/gallery/environment-02", v: 1784645813, w: 1000, h: 1500, f: "jpg" },
  "environment-03": { id: "engape/gallery/environment-03", v: 1784645813, w: 1500, h: 1000, f: "jpg" },
  "environment-04": { id: "engape/gallery/environment-04", v: 1784645813, w: 1500, h: 1000, f: "jpg" },
  "environment-05": { id: "engape/gallery/environment-05", v: 1784645813, w: 1500, h: 1000, f: "jpg" },
  "environment-06": { id: "engape/gallery/environment-06", v: 1784645814, w: 1500, h: 1000, f: "jpg" },
  "environment-07": { id: "engape/gallery/environment-07", v: 1784645814, w: 1000, h: 1500, f: "jpg" },
  "environment-08": { id: "engape/gallery/environment-08", v: 1784645814, w: 1000, h: 1500, f: "jpg" },
  "environment-09": { id: "engape/gallery/environment-09", v: 1784645814, w: 1113, h: 1500, f: "jpg" },
  "environment-10": { id: "engape/gallery/environment-10", v: 1784645814, w: 1113, h: 1500, f: "jpg" },
  "environment-11": { id: "engape/gallery/environment-11", v: 1792403279, w: 1186, h: 1599, f: "jpg" },
  "environment-12": { id: "engape/gallery/environment-12", v: 1792403287, w: 1186, h: 1599, f: "jpg" },
  "environment-13": { id: "engape/gallery/environment-13", v: 1792403281, w: 1186, h: 1599, f: "jpg" },
  "environment-14": { id: "engape/gallery/environment-14", v: 1792403283, w: 1599, h: 1186, f: "jpg" },
  "environment-15": { id: "engape/gallery/environment-15", v: 1792403284, w: 1186, h: 1599, f: "jpg" },
  "environment-16": { id: "engape/gallery/environment-16", v: 1792403287, w: 1186, h: 1599, f: "jpg" },
  "environment-17": { id: "engape/gallery/environment-17", v: 1792403289, w: 1599, h: 1186, f: "jpg" },
  "health-01": { id: "engape/gallery/health-01", v: 1784645814, w: 1192, h: 798, f: "jpg" },
  "health-02": { id: "engape/gallery/health-02", v: 1784645814, w: 1192, h: 803, f: "jpg" },
  "health-03": { id: "engape/gallery/health-03", v: 1784645815, w: 1147, h: 780, f: "jpg" },
  "health-04": { id: "engape/gallery/health-04", v: 1784645815, w: 1192, h: 714, f: "jpg" },
  "health-05": { id: "engape/gallery/health-05", v: 1784645815, w: 1141, h: 780, f: "jpg" },
  "health-06": { id: "engape/gallery/health-06", v: 1784645815, w: 1191, h: 845, f: "jpg" },
  "milestones-01": { id: "engape/gallery/milestones-01", v: 1784645815, w: 1000, h: 1500, f: "jpg" },
  "milestones-02": { id: "engape/gallery/milestones-02", v: 1784645815, w: 1500, h: 1000, f: "jpg" },
  "milestones-03": { id: "engape/gallery/milestones-03", v: 1784645816, w: 1000, h: 1500, f: "jpg" },
  "milestones-04": { id: "engape/gallery/milestones-04", v: 1784645816, w: 1500, h: 1125, f: "jpg" },
  "milestones-05": { id: "engape/gallery/milestones-05", v: 1784645816, w: 1500, h: 1125, f: "jpg" },
  "milestones-06": { id: "engape/gallery/milestones-06", v: 1784645816, w: 1500, h: 1000, f: "jpg" },
  "milestones-07": { id: "engape/gallery/milestones-07", v: 1784645816, w: 1000, h: 1500, f: "jpg" },
  "milestones-08": { id: "engape/gallery/milestones-08", v: 1784645816, w: 1000, h: 1500, f: "jpg" },
  "milestones-09": { id: "engape/gallery/milestones-09", v: 1784645816, w: 1500, h: 1000, f: "jpg" },
  "milestones-10": { id: "engape/gallery/milestones-10", v: 1784645817, w: 1500, h: 1000, f: "jpg" },
  "schools-01": { id: "engape/gallery/schools-01", v: 1784645817, w: 1500, h: 1076, f: "jpg" },
  "schools-02": { id: "engape/gallery/schools-02", v: 1784645817, w: 1280, h: 960, f: "jpg" },
  "schools-03": { id: "engape/gallery/schools-03", v: 1784645817, w: 1473, h: 1105, f: "jpg" },
  "schools-04": { id: "engape/gallery/schools-04", v: 1784645817, w: 1143, h: 797, f: "jpg" },
  "schools-05": { id: "engape/gallery/schools-05", v: 1784645817, w: 1237, h: 833, f: "jpg" },
  "schools-06": { id: "engape/gallery/schools-06", v: 1784645818, w: 1198, h: 812, f: "jpg" },
  "schools-07": { id: "engape/gallery/schools-07", v: 1784645818, w: 1280, h: 805, f: "jpg" },
  "schools-08": { id: "engape/gallery/schools-08", v: 1784645818, w: 1089, h: 753, f: "jpg" },
  "schools-09": { id: "engape/gallery/schools-09", v: 1784645818, w: 1172, h: 804, f: "jpg" },
  "schools-10": { id: "engape/gallery/schools-10", v: 1784645818, w: 1200, h: 815, f: "jpg" },
  "sports-01": { id: "engape/gallery/sports-01", v: 1792403319, w: 4160, h: 3040, f: "jpg" },
  "sports-02": { id: "engape/gallery/sports-02", v: 1792403312, w: 1023, h: 1280, f: "jpg" },
  "sports-03": { id: "engape/gallery/sports-03", v: 1792403315, w: 816, h: 1202, f: "jpg" },
  "sports-04": { id: "engape/gallery/sports-04", v: 1792403316, w: 1145, h: 735, f: "jpg" },
  "sports-05": { id: "engape/gallery/sports-05", v: 1792403319, w: 1280, h: 869, f: "jpg" },
  "sports-06": { id: "engape/gallery/sports-06", v: 1792403319, w: 1078, h: 1600, f: "jpg" },
  "sports-07": { id: "engape/gallery/sports-07", v: 1792403326, w: 1232, h: 816, f: "jpg" },
  "sports-08": { id: "engape/gallery/sports-08", v: 1792403331, w: 2480, h: 4160, f: "jpg" },
  "sports-09": { id: "engape/gallery/sports-09", v: 1792403332, w: 1232, h: 816, f: "jpg" },
};

/** Gallery photograph IDs, in upload order. Data.js pairs these with captions. */
export const galleryIds = [
  "community-01",
  "community-02",
  "community-03",
  "community-04",
  "community-05",
  "community-06",
  "education-01",
  "education-02",
  "education-03",
  "education-04",
  "education-05",
  "education-06",
  "education-07",
  "education-08",
  "education-09",
  "education-10",
  "education-11",
  "education-12",
  "environment-01",
  "environment-02",
  "environment-03",
  "environment-04",
  "environment-05",
  "environment-06",
  "environment-07",
  "environment-08",
  "environment-09",
  "environment-10",
  "environment-11",
  "environment-12",
  "environment-13",
  "environment-14",
  "environment-15",
  "environment-16",
  "environment-17",
  "health-01",
  "health-02",
  "health-03",
  "health-04",
  "health-05",
  "health-06",
  "milestones-01",
  "milestones-02",
  "milestones-03",
  "milestones-04",
  "milestones-05",
  "milestones-06",
  "milestones-07",
  "milestones-08",
  "milestones-09",
  "milestones-10",
  "schools-01",
  "schools-02",
  "schools-03",
  "schools-04",
  "schools-05",
  "schools-06",
  "schools-07",
  "schools-08",
  "schools-09",
  "schools-10",
  "sports-01",
  "sports-02",
  "sports-03",
  "sports-04",
  "sports-05",
  "sports-06",
  "sports-07",
  "sports-08",
  "sports-09"
];
